import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Icon } from 'ui';
import { Tooltip } from 'antd';
import { withRouter } from 'utils/withRouter';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const AlertIcon = styled(Icon)`
  color: ${p => p.theme.colors.alerts['1']};
  font-size: 16px;
`;

const TicketIcon = styled(Icon)`
  color: ${p => p.theme.colors.alerts['3']};
  font-size: 16px;
`;

const OrderIcon = styled(Icon)`
  color: ${p => p.orderType === 'main' && '#ff9600'};
  font-size: 16px;
`;

const IconColumn = ({
  intl,
  history,
  data,
}) => {
  const handleIconClick = (e, redirectUri) => {
    e.stopPropagation();
    history.replace(`/${redirectUri}`);
  };

  const navigateToDocument = (url) => {
    if (url.startsWith('http')) {
      window.open(url, '_blank');
      return;
    }
    window.open(`http://${url}`, '_blank');
  };
  return (
    <Flex
      jcsa
      aic
      marginTop={
        data?.indicators?.isSubOrder || data?.indicators?.isMainOrder ?
          0 :
          6
      }
    >
      {data?.hasAlert || data?.indicators?.hasAlerts ?
        <AlertIcon type='exclamation-circle' /> :
        null
      }
      {data?.hasTicket || data?.indicators?.hasTickets ?
        <TicketIcon
          type='comment'
          onClick={(e) => {
            e.stopPropagation();
            history.push(`/order/${data.id}/tickets/object/${data.id}`);
          }}
        /> :
        null
      }
      {data?.indicators?.hasVisitReports ?
        <TicketIcon
          light={true}
          type='file-alt'
          onClick={(e) => {
            e.stopPropagation();
            navigateToDocument(data.indicators.latestVisitReportUri);
          }}
        /> :
        null
      }
      {data?.indicators?.isSubOrder || data?.indicators?.isMainOrder ?
        <Tooltip
          placement='left'
          title={intl.formatMessage({ id: 'order.fieldEngineer.LINKED_ORDERS_TOOLTIP' })}
        >
          <div>
            <OrderIcon
              orderType={data?.indicators?.isMainOrder && 'main'}
              type={data?.indicators?.isSubOrder ? 'link' : 'crown'}
              onClick={e => handleIconClick(e, data?.indicators?.redirectUri)}
            />
          </div>
        </Tooltip> :
        null
      }
    </Flex>
  );
};

IconColumn.propTypes = {
  intl: PropTypes.object,
  history: PropTypes.object,
  data: PropTypes.object,
};

export default withRouter(injectIntl(IconColumn));
